module.exports = __webpack_public_path__ + "img/3-1.c562520a.svg";